/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { AuthorBadgesContainer_comment$ref } from "./AuthorBadgesContainer_comment.graphql";
import { CaretContainer_comment$ref } from "./CaretContainer_comment.graphql";
import { EditCommentFormContainer_comment$ref } from "./EditCommentFormContainer_comment.graphql";
import { ReactionButtonContainer_comment$ref } from "./ReactionButtonContainer_comment.graphql";
import { RejectedTombstoneContainer_comment$ref } from "./RejectedTombstoneContainer_comment.graphql";
import { ReplyCommentFormContainer_comment$ref } from "./ReplyCommentFormContainer_comment.graphql";
import { ReportButtonContainer_comment$ref } from "./ReportButtonContainer_comment.graphql";
import { UserTagsContainer_comment$ref } from "./UserTagsContainer_comment.graphql";
import { UsernameWithPopoverContainer_comment$ref } from "./UsernameWithPopoverContainer_comment.graphql";
export type COMMENT_STATUS = "APPROVED" | "NONE" | "PREMOD" | "REJECTED" | "SYSTEM_WITHHELD" | "%future added value";
export type COMMENT_VIEWER_ACTION = "APPROVE" | "EDIT" | "REJECT" | "%future added value";
export type TAG = "EXPERT" | "FEATURED" | "STAFF" | "UNANSWERED" | "%future added value";
declare const _CommentContainer_comment$ref: unique symbol;
export type CommentContainer_comment$ref = typeof _CommentContainer_comment$ref;
export type CommentContainer_comment = {
    readonly id: string;
    readonly author: {
        readonly id: string;
        readonly username: string | null;
    } | null;
    readonly parent: {
        readonly author: {
            readonly username: string | null;
        } | null;
    } | null;
    readonly body: string | null;
    readonly createdAt: string;
    readonly status: COMMENT_STATUS;
    readonly editing: {
        readonly edited: boolean;
        readonly editableUntil: string | null;
    };
    readonly tags: ReadonlyArray<{
        readonly code: TAG;
    }>;
    readonly pending: boolean | null;
    readonly lastViewerAction: COMMENT_VIEWER_ACTION | null;
    readonly deleted: boolean | null;
    readonly " $fragmentRefs": ReplyCommentFormContainer_comment$ref & EditCommentFormContainer_comment$ref & ReactionButtonContainer_comment$ref & ReportButtonContainer_comment$ref & CaretContainer_comment$ref & RejectedTombstoneContainer_comment$ref & AuthorBadgesContainer_comment$ref & UserTagsContainer_comment$ref & UsernameWithPopoverContainer_comment$ref;
    readonly " $refType": CommentContainer_comment$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "username",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "CommentContainer_comment",
        "type": "Comment",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "author",
                "storageKey": null,
                "args": null,
                "concreteType": "User",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    (v1 /*: any*/)
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "parent",
                "storageKey": null,
                "args": null,
                "concreteType": "Comment",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "author",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "User",
                        "plural": false,
                        "selections": [
                            (v1 /*: any*/)
                        ]
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "body",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "createdAt",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "status",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "editing",
                "storageKey": null,
                "args": null,
                "concreteType": "EditInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "edited",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "editableUntil",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "tags",
                "storageKey": null,
                "args": null,
                "concreteType": "Tag",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "code",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "deleted",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "FragmentSpread",
                "name": "ReplyCommentFormContainer_comment",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "EditCommentFormContainer_comment",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "ReactionButtonContainer_comment",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "ReportButtonContainer_comment",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "CaretContainer_comment",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "RejectedTombstoneContainer_comment",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "AuthorBadgesContainer_comment",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "UserTagsContainer_comment",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "UsernameWithPopoverContainer_comment",
                "args": null
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "pending",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "lastViewerAction",
                        "args": null,
                        "storageKey": null
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = 'dca10ce0175c55cb7ebc96f351bc4104';
export default node;
